import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import UarFooter from 'components/bolt/uarFooter/uarFooter';
// import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {

	render(props, state) {
		const base = super.render(props, state);
		const { data } = props;
		if (data.uarFooter) {
			base.children.push(<UarFooter data={data.uarFooter} />);
		}
		return base;
	}
}
